import { useState } from 'react';
import dynamic from 'next/dynamic';
import cn from 'classnames';
import { VariantsProps } from './types';
import Variant from './Variant';
import { ConditionPopup } from '@/components/products/conditionPopup/ConditionPopup';
import AdditionalItem from '@/components/commons/AdditionalItem';
import WarrantySlideOver from '../../../WarrantySlideOver';

const TradeInSection = dynamic(() => import('../../TradeIn/TradeInSection'), {
  ssr: false,
});

const Variants: React.FC<VariantsProps> = ({
  isConditionOpen,
  setIsConditionOpen,
  product,
  offer,
  productWarranty,
  handleWarrantyClick,
  warrantyID,
  setShowTradeInModal,
  isTradeInEligible,
  categoryPk,
  selection,
  offerTree,
  rVariants = [],
  categoryParentName,
}) => {
  const [wasSuggested, setWasSuggested] = useState<string | null>(null);

  return (
    <div className="mb-4 rounded-md border-gray-200 p-0 sm:text-xs lg:border lg:p-4">
      <ConditionPopup
        activeCondition={
          offer?.rVariants
            ?.find((v) => v.handle === 'condition')
            ?.value?.replace('Very Good', 'Good') ?? ''
        }
        isOpen={isConditionOpen}
        onClose={() => setIsConditionOpen(false)}
        categoryPk={categoryPk}
      />
      <div className="space-y-4">
        {/* Render all available variants */}
        {rVariants.map((rVariant) => (
          <Variant
            key={`${rVariant.name}-${rVariant.handle}`}
            rVariant={rVariant}
            offer={offer}
            offerTree={offerTree}
            selection={selection}
            product={product}
            setWasSuggested={setWasSuggested}
            wasSuggested={wasSuggested}
            categoryParentName={categoryParentName}
          />
        ))}
      </div>
      {/* Show message when a variant was suggested */}
      {productWarranty && (
        <div className="mt-5">
          <AdditionalItem
            Modal={WarrantySlideOver}
            price={productWarranty.price}
            onClick={handleWarrantyClick}
            isActive={warrantyID !== null}
            imageUrl={offer.imageSrc}
            duration={productWarranty.duration}
          />
        </div>
      )}
      {/* Trade In */}
      <div
        className={cn({
          'mt-4': isTradeInEligible,
        })}
      >
        <TradeInSection
          setShowModal={setShowTradeInModal}
          eligible={isTradeInEligible}
        />
      </div>
    </div>
  );
};

export default Variants;
